import React from 'react';

export class Welcome extends React.Component {
  componentDidMount(): void {
    const url = window.location.toString();
    window.location.replace(url.replace('/welcome', '/welcome.html'));
  }

  render() {
    return null;
  }
}
